import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, SmartphoneIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Bonus" className="border-y border-grape/10 bg-white/70" data-id="element-16" data-mp="avcxel4e1k8y">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "22px"
    }} data-id="element-17" data-mp="at8ua5ebcp9q">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-18" data-mp="1uet01q1fapu">
          🎁 4 Bonus Gratuits Inclus
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm font-bold uppercase tracking-wide text-blush" data-id="element-19" data-mp="5x1l83qmexnk">
          Seulement pour aujourd'hui
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-20" data-mp="3t0ogy264l9mo">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative flex gap-4 rounded-2xl border border-grape/20 bg-cream p-6" style={{
          paddingTop: "16px",
          paddingBottom: "16px"
        }} data-id="element-21" data-mp="3t2j65sofjnwk" data-mpi={i}>
              <img src={b.cover} alt={`Couverture du bonus ${b.title}`} width={1122} height={1402} loading="lazy" decoding="async" sizes="112px" className="aspect-[4/5] h-auto w-24 shrink-0 self-start rounded-lg object-cover shadow-[0_10px_18px_-6px_rgba(42,21,18,0.45)] ring-1 ring-plum/10 sm:w-28" data-id="element-22" data-mp="3r700bno8dhdr" />
              <div className="flex min-w-0 flex-col" data-id="element-23" data-mp="2uhiwzfcq07f8">
                <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-24" data-mp="2uiu15ga2vh6v">
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-lilac-soft px-3 py-1 text-xs font-bold text-grape" data-id="element-25" data-mp="38e5ubj8l4zlo">
                    <GiftIcon className="h-3.5 w-3.5" data-id="element-26" data-mp="nozzqtl08ea6" /> Bonus {b.n}
                  </span>
                  <span className="whitespace-nowrap text-sm font-bold" data-id="element-27" data-mp="irq0km7tco95">
                    <span className="text-plum/40" data-id="element-28" data-mp="3cj6iqhppjyqy">Valeur </span>
                    <span className="text-plum/40 line-through" data-id="element-29" data-mp="3cin1z4bsngei">{b.price}</span>{' '}
                    <span className="text-blush" data-id="element-30" data-mp="3hgg3hk25jm8g">GRATUIT</span>
                  </span>
                </div>
                <h3 className="text-base font-bold text-plum" data-id="element-31" data-mp="3lke3ry37r333">{b.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-plum/65" data-id="element-32" data-mp="3qhml5wgjf33a">{b.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <p className="mt-8 flex items-center justify-center gap-2 text-sm font-semibold text-plum/60" data-id="element-33" data-mp="2tqls76xhe5qb">
          <SmartphoneIcon className="h-4 w-4 text-grape" aria-hidden="true" data-id="element-34" data-mp="2xrnslr34wntv" />
          Accédez à tout depuis votre ordinateur, tablette ou téléphone.
        </p>

        <div className="mt-6 rounded-2xl border border-blush/30 bg-blush-soft p-6 text-center" style={{
        paddingTop: "11px",
        paddingBottom: "11px"
      }} data-id="element-35" data-mp="37lefirjm4q7g">
          <p className="text-base font-bold text-plum sm:text-lg" data-id="element-36" data-mp="2f30pvf8fkajg">
            💰 Valeur Totale : <span className="text-plum/50 line-through" data-id="element-37" data-mp="27jrhnpbnuhvz">111 €+</span>{' '}
            <span className="text-[15px] text-blush-deep" data-id="element-38" data-mp="27hx4wyajlw2z">
              AUJOURD'HUI GRATUIT AVEC LE COMBO 5-EN-1
            </span>
          </p>
        </div>
      </div>
    </section>;
}